<template>
  <div class="f360-banner-aviso">
    <div class="content-left">
      <img class="hidden-sm-and-down" :src="logo" alt="logo antecipa" />
      <!-- <p>Chegou o <b>Antecipa</b> na F360. Uma solução para <b>antecipar</b> suas <b>vendas de cartões</b></p> -->
      <p>
        Realize suas antecipações no <b>F360 Antecipa</b> com taxas a partir de
        <b>0,99% a.m.</b>?
      </p>
    </div>
    <div class="content-right">
      <!-- <p>Conheça nossas ofertas</p> -->
      <el-button class="banner-button" @click="handleLink">
        <span class="banner-button__label">
          Simule<span class="display-btn-text hidden-sm-and-down"
            >sem compromisso</span
          >
          <MaterialIcon class="banner-button__icon" icon="north_east" />
        </span>
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import logo from "@/features/antecipa/assets/logo-antecipa.png";
import { ElButton } from "element-plus/es/components/button/index";
import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";

const emits = defineEmits(["VCBannerClick"]);

const handleLink = () => {
  emits("VCBannerClick");
};
</script>

<style lang="scss" scoped>
@use "@/ui/styles/theme/f360-theme" as *;
@use "@/ui/styles/variables" as *;

.f360-banner-aviso {
  font-family: $fontFamily;
  width: auto;
  height: 1.875rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem;
  background-color: #fffec1;
  border-radius: 0.3125rem;
  color: #2e2e2e;
  font-weight: 400;
  font-size: 14px;
  line-height: 32px;

  .content-left {
    display: flex;
    align-items: center;

    img {
      margin-right: 10px;
    }
  }

  .content-right {
    display: flex;
    align-items: center;

    p {
      margin-right: 10px;
    }
  }

  .banner-button {
    height: 32px;
    width: fit-content;
    padding: 0 5px;
    border-radius: 5px;
    border: 1px solid #e7e7e7;
    background-color: #fff;
    color: #d19700;
    cursor: pointer;

    &__label {
      display: flex;
      align-items: center;
      gap: 3px;

      font-family: $fontFamily;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;

      &--small {
        font-size: 10px;
        line-height: 10px;
      }
    }

    &__icon {
      font-size: 18px;
    }

    @media (min-width: 768px) and (max-width: 1200px) {
      .display-btn-text {
        display: none;
      }
    }
  }

  .banner-button:hover {
    background-color: #d19700;
    color: #ffffff;
  }

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: auto;

    .content-left {
      display: flex;
      flex-direction: column;

      p {
        text-align: center;
      }
    }
  }
}
</style>
